import React from 'react';
import styled from 'styled-components';
import  ModalCore from './ModalCore.js';
import { connect } from "react-redux";
import {setValues , actCloseModal} from './redux';
import { Imglist } from './../../constants/ImagesList';

const RuleModal = (props) => {
	return (
		<ModalCore name="rule" outSideClick={true}>
			<RuleModalContent className="rulemessage">
                <div className="rulemessage__close" onClick={()=>props.setValues({modal_open: ''})}>
                    <img src={Imglist.btn_close} alt=''/>
                </div>
                <div className="rulemessage__head">
                    รายละเอียดกิจกรรม FCOnline PROLYMPIC
				</div>
                <div className="rulemessage__rulecontent">
                    <div className="rulemessage__text-title-small">
                        เลือกทีมที่ชอบ ทีมที่ใช่เพื่อสะสมแต้มในการแข่งขันกับทีมอื่นๆ
                    </div>
                    <div className="rulemessage__text-head">
                        กติกา
                    </div>
                    <ul className="rulemessage__rule">
                        <li>เล่น Ranked Match (1v1 ranked, 2v2 ranked, Manager ranked (PC/Mobile), Volta Live ranked) ชนะ นับ 5 แต้ม</li>
                        <li>เล่น Ranked Match (1v1 ranked, 2v2 ranked, Manager ranked (PC/Mobile), Volta Live ranked) เสมอ นับ 3 แต้ม</li>
                        <li>เล่น Ranked Match (1v1 ranked, 2v2 ranked, Manager ranked (PC/Mobile), Volta Live ranked) แพ้ นับ 1 แต้ม</li>
                        <li>เมื่อจบกิจกรรม ผู้เล่นต้องมีคะแนนอย่างน้อย 20 คะแนนขึ้นไปจึงจะได้รับของรางวัลประจำทีม</li>
                    </ul>
                    <div className="rulemessage__hr"></div>
                    <div className="rulemessage__text-head">
                        ระยะเวลากิจกรรม
                    </div>
                    <div className="rulemessage__text-title-small">
                        20 ตุลาคม - 18 พฤศจิกายน 2566 เวลา 23:59 น.
                    </div>
                    <div className="rulemessage__hr"></div>
                    <div className="rulemessage__text-head">
                        รางวัล
                    </div>
                    <ul className="rulemessage__reward">
                        <li>ผู้เล่นที่ทำคะแนนได้มากที่สุดตลอดกิจกรรม เพียง 1 เดียวเท่านั้น! ที่จะได้รับตำแหน่ง KING OF RANKING และจะได้รับของรางวัลพิเศษ!</li>
                        <li>ผู้เล่นที่ได้รับอับดับ 1-3 ของทีมที่เลือก จะได้รับของรางวัลพิเศษเพิ่มเติม!</li>
                        <li>หลังจบกิจกรรมผู้เล่นจะได้รับรางวัลตามลำดับของทีมที่เลือก</li>
                        <li>*ของรางวัลจะได้รับหลังจบกิจกรรมภายในไม่เกิน 72 ชม.</li>
                    </ul>
                </div>
                <div className="rulemessage__ok" onClick={()=>props.setValues({modal_open: ''})}>
					<img src={Imglist.btn_ok} alt=''/>
				</div>
			</RuleModalContent>
		</ModalCore>
	)
}

const mapStateToProps = state => ({
    ...state.Modal
});

const mapDispatchToProps = { setValues ,actCloseModal};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(RuleModal);

const RuleModalContent = styled.div`
    position: relative;
    z-index: 20;
    padding: 2%;
    pointer-events: visible;
    width: 90%;
    max-width: 700px;
    .rulemessage{
        &__rulecontent{
            max-height: 55vh;
            overflow-y: scroll;
            width: 100%;
            margin: 0 auto;
            background: rgba(243,211,230,.8);
            border-bottom-right-radius: 25px;
            padding: 2%;
        }
        &__text-head{
            color: #f80052;
            font-size: 1.5em;
            text-align: center;
        }
        &__text-title-small{
            color: #000;
            font-size: 1.1em;
            text-align: center;
        }
        &__rule{
            padding-left: 6%;
            font-size: 1.1em;
            color: #000;
            >li{
                list-style-type: disc;
                &:last-child{
                    list-style-type: none;
                }
            }
        }
        &__reward{
            padding-left: 6%;
            font-size: 1.1em;
            color: #000;
            >li{
                list-style-type: decimal;
                &:last-child{
                    list-style-type: none;
                }
            }
        }
        &__head{
            text-align: center;
            font-size: 1.5em;
            color: #fff;
            background: rgba(255,0,76,1);
            background: -moz-linear-gradient(top, rgba(255,0,76,1) 0%, rgba(255,0,123,1) 53%, rgba(255,0,123,1) 100%);
            background: -webkit-gradient(left top, left bottom, color-stop(0%, rgba(255,0,76,1)), color-stop(53%, rgba(255,0,123,1)), color-stop(100%, rgba(255,0,123,1)));
            background: -webkit-linear-gradient(top, rgba(255,0,76,1) 0%, rgba(255,0,123,1) 53%, rgba(255,0,123,1) 100%);
            background: -o-linear-gradient(top, rgba(255,0,76,1) 0%, rgba(255,0,123,1) 53%, rgba(255,0,123,1) 100%);
            background: -ms-linear-gradient(top, rgba(255,0,76,1) 0%, rgba(255,0,123,1) 53%, rgba(255,0,123,1) 100%);
            background: linear-gradient(to bottom, rgba(255,0,76,1) 0%, rgba(255,0,123,1) 53%, rgba(255,0,123,1) 100%);
            filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ff004c', endColorstr='#ff007b', GradientType=0 );
            border-top-left-radius: 25px;
        }
        &__close{
            position: absolute;
            width: 6%;
            right: -3%;
            top: -3%;
            cursor: pointer;
            >img{
                display: block;
            }
            @media(max-width: 850px) {
                right: 0;
                top: -2%;
            }
        }
        &__ok{
            width: 26%;
            margin: 1% auto 0;
            cursor: pointer;
            &:hover{
                opacity: .8;
            }
            >img{
                display: block;
            }
        }
        &__hr{
            width: 80%;
            margin: 2% auto;
            border-top: 1px solid #000
        }
    }
`;

